import { STAGE_ELEMENT } from "../../../../constants";

const STAGE_ELEMENT_CLASS_NAMES: Partial<Record<string, string>> = {
  [STAGE_ELEMENT.TEXT]: "spf-element-text",
  [STAGE_ELEMENT.IMAGE]: "spf-element-image",
  [STAGE_ELEMENT.PLUGIN]: "spf-element-plugin",
  [STAGE_ELEMENT.EMBED]: "spf-element-embed",
  [STAGE_ELEMENT.TABLE]: "spf-element-table",
  [STAGE_ELEMENT.SHOWHIDE]: "spf-element-show-hide",
};

const BASE_STAGE_ELEMENT_CLASS = "spf-rce-element";

export const getStageElementClassName = (type?: string): string => {
  const elementClass = type ? STAGE_ELEMENT_CLASS_NAMES[type] : undefined;
  return elementClass ? `${BASE_STAGE_ELEMENT_CLASS} ${elementClass}` : BASE_STAGE_ELEMENT_CLASS;
};
